/**
 * URL helpers shared by client + server. Photos are LINK-ONLY and never uploaded or stored — we
 * only keep a pasted public image link. isHttpsImageUrl gates that link on both ends.
 */

/** True for an https URL whose path ends in a common image extension (optional query/hash). */
export function isHttpsImageUrl(url: string | undefined | null): boolean {
  const u = (url ?? '').trim();
  return /^https:\/\/\S+\.(jpe?g|png|gif|webp|avif)(\?\S*)?(#\S*)?$/i.test(u);
}

/** True for any http(s) URL (used for the generic "link" field). */
export function isHttpUrl(url: string | undefined | null): boolean {
  return /^https?:\/\/\S+$/i.test((url ?? '').trim());
}
